import { ButtonAnchor } from "@components/Buttons"
import { useIntl } from "@components/Intl"
import IntlLink from "@components/Intl/IntlLink"
import { TitleS } from "@components/Typography"
import { theme } from "@config/theme"
import React, { FC } from "react"
import * as S from "./elements"

type NoResultsProps = {
  query: string
}

export const NoResults: FC<NoResultsProps> = ({ query }) => {
  const { locale, messages } = useIntl()
  return (
    <S.Parent>
      <TitleS mb={["1.25rem", "2rem"]} color={theme.colors.text.light}>
        {locale === "nl"
          ? `Geen resultaten voor ${query}. Probeer een andere zoekterm, of neem contact op als u vragen heeft.`
          : `No results for ${query}. Try a different search term, or get in touch if you have any questions.`}
      </TitleS>
      <IntlLink
        href={messages.navigation.contact.url}
        as={messages.navigation.contact.url}
      >
        <ButtonAnchor icon="arrow-right" maxWidth="11rem">
          Contact
        </ButtonAnchor>
      </IntlLink>
    </S.Parent>
  )
}
